import React from "react";
import {
  HiOutlineServer,
  HiOutlineDesktopComputer,
  HiOutlineDatabase,
  HiOutlineCog,
  HiOutlineLightBulb,
  HiOutlineCode,
} from "react-icons/hi";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import { skillGroups } from "../../data";

const CATEGORY_ICONS = {
  "Backend":               <HiOutlineServer />,
  "Frontend":              <HiOutlineDesktopComputer />,
  "Databases":             <HiOutlineDatabase />,
  "DevOps":                <HiOutlineCog />,
  "AI / LLM":              <HiOutlineLightBulb />,
  "Engineering Practices": <HiOutlineCode />,
};

function Skills() {
  const headerRef = useScrollReveal();
  const gridRef   = useScrollReveal();

  return (
    <section id="skills" className="section skills-section">
      <div className="section-inner">
        <div ref={headerRef} className="reveal" style={{ marginBottom: "48px" }}>
          <p className="section-label">Expertise</p>
          <h2 className="section-title">
            Technical <span>Skills</span>
          </h2>
          <p className="section-subtitle">
            A broad stack covering backend, frontend, cloud, databases, and AI — with deep expertise in .NET and React ecosystems.
          </p>
        </div>

        <div ref={gridRef} className="skills-grid reveal">
          {skillGroups.map((group, i) => (
            <div
              key={group.category}
              className="skill-group-card"
              style={{ transitionDelay: `${i * 0.07}s` }}
            >
              <div className="skill-group-header">
                <div className="skill-group-icon">
                  {CATEGORY_ICONS[group.category] || <HiOutlineCode />}
                </div>
                <span className="skill-group-name">{group.category}</span>
              </div>
              <div className="skill-pills">
                {group.skills.map((skill) => (
                  <span key={skill} className="skill-pill">{skill}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
